module.exports = __webpack_public_path__ + "img/law-pavillion.87b04b88.png";